import { LoginComponent } from './login.component';
import { NgModule } from '@angular/core';
import { CommonModule, NgIf } from '@angular/common';

import { LoginRoutingModule } from './login-routing.module';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [LoginComponent],
  imports: [CommonModule, LoginRoutingModule, NgbToastModule],
  
})
export class LoginModule {}
